import { Lightbulb, Palette, Recycle } from "lucide-react";

export default function ObsessionPromise({ data }) {
    return (<div className="root_track_pr">
        <section className="promise-section">
            <div className="promise-header">
                <h2>
                    The Obsession <span>Promise</span>
                </h2>
                <p>{data?.obsession_promise?.description}</p>
            </div>

            <div className="promise-features">
                <div className="feature-item">
                    <Palette className="feature-icon" strokeWidth={1.2} />
                    <h3>CRAFTSMANSHIP</h3>
                    <p>{data?.obsession_promise?.craftsmanship}</p>
                </div>

                <div className="feature-item">
                    <Lightbulb className="feature-icon" strokeWidth={1.2} />
                    <h3>INNOVATION</h3>
                    <p>{data?.obsession_promise?.innovation}</p>
                </div>

                <div className="feature-item">
                    <Recycle className="feature-icon" strokeWidth={1.2} />
                    <h3>SUSTAINABILITY</h3>
                    <p>{data?.obsession_promise?.sustainability}</p>
                </div>
            </div>
        </section>
    </div>
    )
}
